(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orynlo-header"]) return;
  try {
    
(()=>{const modal=document.querySelector('[data-country-modal]');const opener=document.querySelector('[data-country-open]');if(!modal||!opener)return;const select=modal.querySelector('[data-country-selector]');const currency=modal.querySelector('[data-country-currency]');const open=()=>{modal.hidden=false;document.body.classList.add('orynlo-market-open');setTimeout(()=>select?.focus(),0)};const close=()=>{modal.hidden=true;document.body.classList.remove('orynlo-market-open');opener.focus()};opener.addEventListener('click',open);modal.querySelectorAll('[data-country-close]').forEach(button=>button.addEventListener('click',close));select?.addEventListener('change',()=>{const match=select.options[select.selectedIndex]?.text.match(/\(([A-Z]{3})\)$/);if(currency&&match)currency.textContent=match[1]});document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!modal.hidden)close()})})();
(()=>{const modal=document.querySelector('[data-voucher-modal]');const opener=document.querySelector('[data-voucher-open]');if(!modal||!opener)return;const timer=modal.querySelector('[data-voucher-timer]');const countdown=modal.querySelector('[data-voucher-countdown]');const storageKey='orynloVoucherDeadline';let deadline=Number(sessionStorage.getItem(storageKey));if(!Number.isFinite(deadline)||deadline<=0){deadline=Date.now()+1800000;sessionStorage.setItem(storageKey,String(deadline))}const open=()=>{modal.hidden=false;document.body.classList.add('orynlo-voucher-open');modal.querySelector('[data-voucher-close]')?.focus()};const close=()=>{modal.hidden=true;document.body.classList.remove('orynlo-voucher-open');opener.focus()};const tick=()=>{const remaining=Math.max(0,deadline-Date.now());if(remaining===0){if(timer)timer.textContent='Daily voucher is still available';return}const hours=Math.floor(remaining/3600000);const minutes=Math.floor(remaining%3600000/60000);const seconds=Math.floor(remaining%60000/1000);if(countdown)countdown.textContent=[hours,minutes,seconds].map(value=>String(value).padStart(2,'0')).join(':')};opener.addEventListener('click',open);modal.querySelectorAll('[data-voucher-close]').forEach(button=>button.addEventListener('click',close));document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!modal.hidden)close()});tick();setInterval(tick,1000)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orynlo-home-video"] && !Shopify.designMode) return;
  try {
    
const initializeOrynloLoopVideos = (root = document) => {
  root.querySelectorAll('[data-ohv-loop-video]').forEach((video) => {
    if (video.dataset.ohvInitialized === 'true') return;
    video.dataset.ohvInitialized = 'true';
    video.controls = false;
    video.loop = true;
    video.muted = true;
    video.defaultMuted = true;

    const keepPlaying = () => {
      if (video.ended) video.currentTime = 0;
      if (video.paused && document.visibilityState === 'visible') {
        video.play().catch(() => {});
      }
    };

    const restartVideo = () => {
      video.currentTime = 0;
      video.play().catch(() => {});
    };

    const enableSound = () => {
      video.muted = false;
      video.defaultMuted = false;
      keepPlaying();
      document.removeEventListener('pointerdown', enableSound);
      document.removeEventListener('keydown', enableSound);
      document.removeEventListener('touchstart', enableSound);
    };

    video.addEventListener('pause', keepPlaying);
    video.addEventListener('ended', restartVideo);
    video.addEventListener('click', keepPlaying);
    video.addEventListener('contextmenu', (event) => event.preventDefault());
    document.addEventListener('visibilitychange', keepPlaying);
    document.addEventListener('pointerdown', enableSound, { once: true });
    document.addEventListener('keydown', enableSound, { once: true });
    document.addEventListener('touchstart', enableSound, { once: true, passive: true });
    keepPlaying();
  });
};

initializeOrynloLoopVideos();
document.addEventListener('shopify:section:load', (event) => initializeOrynloLoopVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orynlo-landing-v2"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.olp[data-market-country]').forEach(root=>{const key='olp-us-market-switch';if(root.dataset.marketCountry==='US'){sessionStorage.removeItem(key);return}if(sessionStorage.getItem(key)==='1')return;sessionStorage.setItem(key,'1');const form=document.createElement('form');form.method='POST';form.action='/localization';[['_method','PUT'],['country_code','US'],['return_to',location.pathname+location.search]].forEach(([name,value])=>{const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;form.appendChild(input)});document.body.appendChild(form);form.submit()});


document.addEventListener('click',event=>{const thumb=event.target.closest('[data-gallery-image]');if(thumb){const root=thumb.closest('.olp');const image=root.querySelector('.olp__main-image img');image.src=thumb.dataset.galleryImage;image.alt=thumb.dataset.galleryAlt||'';root.querySelectorAll('.olp__thumb').forEach(item=>item.classList.remove('is-active'));thumb.classList.add('is-active')}const sticky=event.target.closest('[data-sticky-submit]');if(sticky){sticky.closest('.olp').querySelector('.olp__form button[type="submit"]')?.click()}});document.addEventListener('change',event=>{if(!event.target.matches('[data-offer-price]'))return;const root=event.target.closest('.olp');const quantity=root.querySelector('[data-offer-quantity]');if(quantity)quantity.value=event.target.value;const stickyPrice=root.querySelector('[data-sticky-price]');if(stickyPrice)stickyPrice.textContent=event.target.dataset.offerPrice});document.addEventListener('submit',async event=>{const form=event.target.closest('.olp__form[data-buy-now="true"]');if(!form)return;event.preventDefault();const button=form.querySelector('button[type="submit"]');if(button)button.disabled=true;try{const addUrl=new URL(form.action,window.location.href);addUrl.pathname=window.Shopify.routes.root+'cart/add.js';const response=await fetch(addUrl,{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(form.elements.id.value),quantity:Number(form.elements.quantity.value||1)}]})});if(!response.ok){const result=await response.json().catch(()=>({}));throw new Error(result.description||'Unable to add item')};if(button)button.disabled=false;const cartLink=document.querySelector('a[href$="/cart"]');if(cartLink){cartLink.click()}else{window.location.assign(window.Shopify.routes.root+'cart')}}catch(error){if(button){button.disabled=false;button.textContent='TRY AGAIN'}console.error(error)}});
document.querySelectorAll('[data-story-video]').forEach(video=>{video.muted=true;video.loop=true;video.playsInline=true;const play=()=>video.play().catch(()=>{});if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){play()}else{video.pause()}})},{threshold:.15});observer.observe(video)}else{play()}video.addEventListener('canplay',play,{once:true})});
document.querySelectorAll('[data-countdown]').forEach(timer=>{const hoursOutput=timer.querySelector('[data-countdown-hours]');const minutesOutput=timer.querySelector('[data-countdown-minutes]');const secondsOutput=timer.querySelector('[data-countdown-seconds]');const accessibleOutput=timer.querySelector('[data-countdown-accessible]');const key='olp-countdown-'+location.pathname;let end=Number(sessionStorage.getItem(key));if(!end||end<=Date.now()){end=Date.now()+Number(timer.dataset.minutes||15)*60000;sessionStorage.setItem(key,String(end));}const update=()=>{const remaining=Math.max(0,end-Date.now());const totalSeconds=Math.ceil(remaining/1000);const hours=Math.floor(totalSeconds/3600);const minutes=Math.floor(totalSeconds%3600/60);const seconds=totalSeconds%60;hoursOutput.textContent=String(hours).padStart(2,'0');minutesOutput.textContent=String(minutes).padStart(2,'0');secondsOutput.textContent=String(seconds).padStart(2,'0');accessibleOutput.textContent=hours+' hours, '+minutes+' minutes, '+seconds+' seconds remaining';if(remaining<=0&&interval)clearInterval(interval)};let interval;update();interval=setInterval(update,1000)});

  } catch(e) { console.error(e); }
})();
})();
